<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-space-y-4">
        <div class="row">
          <div class="col-md-6">
            <label class="required">{{ $t('locationVisitation.date') }}</label>
            <a-date-picker
              v-model="model.plan_date"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              class="ts-w-full"
            ></a-date-picker>
            <div class="validate" v-if="errors.has('plan_date')">
              {{ errors.first('plan_date') }}
            </div>
          </div>
          <div class="col-md-6">
            <label class="required">{{
              $t('locationVisitation.saleName')
            }}</label>
            <a-select
              v-model.number="model.sale_id"
              :options="saleList"
              @change="fetchAddress"
              class="ts-w-full"
              showSearch
              :filterOption="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
            ></a-select>
            <div class="validate" v-if="errors.has('sale_id')">
              {{ errors.first('sale_id') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="required">{{
              $t('locationVisitation.address')
            }}</label>
            <div class="ts-relative ts-border ts-p-3 ts-rounded">
              <a
                href="#"
                class="ts-bg-blue-200 ts-px-2 ts-py-1 ts-rounded-full ts-shadow ts-absolute ts-top-0 ts-right-0 ts--mt-3 ts--mr-3"
                @click.prevent="addNew"
                ><i class="fa fa-plus"></i
              ></a>
              <table>
								<thead>
									<tr>
										<th>{{$t('locationVisitation.province')}}</th>
										<th>{{$t('locationVisitation.district')}}</th>
										<th>{{$t('locationVisitation.commune')}}</th>
										<th>{{$t('locationVisitation.arrivalTime')}}</th>
										<th>{{$t('locationVisitation.durationInMinute')}}</th>
									</tr>
								</thead>
                <tbody>
                  <tr v-for="(list, index) in model.commune_list" :key="index">
                    <td valign="top">
                      <a-select
                        v-model="list.province_code"
                        class="ts-w-full"
                        style="width:300px"
                        :options="provinces"
                        @change="onProvinceChange(list)"
                        showSearch
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                      ></a-select>
                      <div
                        class="validate"
                        v-if="
                          errors.has('commune_list.' + index + '.province_code')
                        "
                      >
                        {{
                          errors.first(
                            'commune_list.' + index + '.province_code'
                          )
                        }}
                      </div>
                    </td>
                    <td valign="top">
                      <a-select
                        v-model="list.district_code"
                        class="ts-w-full"
                        style="width:250px"
                        :options="districtList(list.province_code)"
                        @change="onDistrictChange(list)"
                        showSearch
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                      ></a-select>
                      <div
                        class="validate"
                        v-if="
                          errors.has('commune_list.' + index + '.district_code')
                        "
                      >
                        {{
                          errors.first(
                            'commune_list.' + index + '.district_code'
                          )
                        }}
                      </div>
                    </td>
                    <td valign="top">
                      <a-select
                        v-model="list.commune_code"
                        :options="
                          communeList({
                            commune_code: list.commune_code,
                            district_code: list.district_code
                          })
                        "
                        style="width:250px"
                      ></a-select>
                      <div
                        class="validate"
                        v-if="
                          errors.has('commune_list.' + index + '.commune_code')
                        "
                      >
                        {{
                          errors.first(
                            'commune_list.' + index + '.commune_code'
                          )
                        }}
                      </div>
                    </td>
                    <td valign="top">
                      <a-time-picker
                        v-model="list.arrival_time"
                        use12-hours
                        format="h:mm a"
                        valueFormat="HH:mm:ss"
                        class="ts-w-full"
                        :placeholder="$t('locationVisitation.arrivalTime')"
                      />
                      <div
                        class="validate"
                        v-if="
                          errors.has('commune_list.' + index + '.arrival_time')
                        "
                      >
                        {{
                          errors.first(
                            'commune_list.' + index + '.arrival_time'
                          )
                        }}
                      </div>
                    </td>
                    <td class="ts-w-48" valign="top">
                      <select
                        class="form-control"
                        v-model.number="list.duration_in_minute"
                      >
                        <option value="">{{
                          $t('locationVisitation.durationInMinute')
                        }}</option>
                        <option :value="30">30 minutes</option>
                        <option :value="60">60 minutes</option>
                        <option :value="90">90 minutes</option>
                        <option :value="120">120 minutes</option>
                        <option :value="180">180 minutes</option>
                        <option :value="240">240 minutes</option>
                        <option :value="300">300 minutes</option>
                        <option :value="360">360 minutes</option>
                        <option :value="420">420 minutes</option>
                        <option :value="480">480 minutes</option>
                        <option :value="540">540 minutes</option>
                      </select>
                      <div
                        class="validate"
                        v-if="
                          errors.has(
                            'commune_list.' + index + '.duration_in_minute'
                          )
                        "
                      >
                        {{
                          errors.first(
                            'commune_list.' + index + '.duration_in_minute'
                          )
                        }}
                      </div>
                    </td>
                    <td class="ts-text-center ts-w-6" valign="middle">
                      <a href="#" @click.prevent="remove(index)">
                        <i class="fa fa-trash text-red"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- <a-select
							v-model="model.commune_list"
							mode="multiple" 
							class="ts-w-full"
							:options="communes"
							showSearch
							:filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
						></a-select>
						<div class="validate" v-if="errors.has('commune_list')">
							{{ errors.first('commune_list') }}
						</div> -->
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-mt-3 text-right">
            <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
              {{ $t('cancel') }}
            </ts-button>
            <ts-button
              v-if="!isUpdate"
              class="mr-2"
              color="primary"
              outline
              @click.prevent="onSaveAddNew"
              :waiting="waiting_new"
              >{{ $t('save_add_new') }}</ts-button
            >
            <ts-button
              v-if="!isUpdate"
              color="primary"
              @click.prevent="onSave"
              :waiting="waiting"
              >{{ $t('save') }}</ts-button
            >
            <ts-button
              v-if="isUpdate"
              color="primary"
              @click.prevent="onUpdate"
              :waiting="waiting"
              >{{ $t('update') }}</ts-button
            >
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import { includes } from 'lodash'

export default {
  name: 'visitCustomer',
  data() {
    return {
      loading: false,
      waiting_new: false,
      waiting: false,
      errors: new Errors(),
      model: {
        plan_id: null,
        sale_id: null,
        plan_date: moment().format('DD-MM-YYYY'),
        commune_list: [
          {
            province_code: '',
            district_code: '',
            commune_code: '',
            arrival_time: '',
            duration_in_minute: ''
          }
        ]
      }
    }
  },
  created() {
    this.loading = true
    this.fetchResources().finally(() => {
      this.loading = false
    })
    this.setEditData()
  },
  computed: {
    ...mapState('customer/locationVisitation', [
      'edit_data',
      'provinces',
      'districts',
      'communes'
    ]),
    districtList: vm => provinceCode => {
      return vm.districts.filter(d => d.province_code == provinceCode)
    },
    communeList: vm => ({ commune_code, district_code }) => {
      return vm.communes
        .filter(c => c.district_code == district_code)
        .filter(
          c =>
            !includes(
              vm.model.commune_list
                .filter(mc => mc.commune_code != commune_code)
                .map(el => el.commune_code),
              c.value
            )
        )
    },
    saleList() {
      return this.$store.state.customer.locationVisitation.salers.map(el => ({
        value: el.user_id,
        label: el.name
      }))
    },
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    }
  },
  methods: {
    ...mapActions('customer/locationVisitation', [
      'fetchResources',
      'getAddress'
    ]),
    addNew() {
      this.model.commune_list.push({
        province_code: '',
        district_code: '',
        commune_code: '',
        arrival_time: '',
        duration_in_minute: ''
      })
    },
    remove(index) {
      this.model.commune_list.splice(index, 1)
    },
    onSave() {
      this.waiting = true
      this.errors = new Errors()
      this.$store
        .dispatch('customer/locationVisitation/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSaveAddNew() {
      this.waiting_new = true
      this.errors = new Errors()
      this.$store
        .dispatch('customer/locationVisitation/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.errors = new Errors()
      this.$store
        .dispatch('customer/locationVisitation/update', {
          id: this.model.plan_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    clearInput() {
      this.model.plan_id = null
      this.model.sale_id = null
      this.model.plan_date = moment().format('DD-MM-YYYY')
      this.model.commune_list = [
        {
          province_code: '',
          district_code: '',
          commune_code: '',
          arrival_time: '',
          duration_in_minute: ''
        }
      ]
    },
    onProvinceChange(row) {
      row.district_code = ''
      row.commune_code = ''
      row.arrival_time = ''
      row.duration_in_minute = ''
		},
    onDistrictChange(row) {
      row.commune_code = ''
		},
    async fetchAddress(saleId) {
      this.loading = true
      this.model.commune_list = [
        {
          province_code: '',
          district_code: '',
          commune_code: '',
          arrival_time: '',
          duration_in_minute: ''
        }
      ]
      this.getAddress(saleId).finally(() => (this.loading = false))
    },
    async setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        await this.getAddress(this.edit_data.sale_id)
        this.model.plan_id = this.edit_data.plan_id
        this.model.sale_id = this.edit_data.sale_id
        this.model.plan_date = this.edit_data.plan_date
        this.model.commune_list = this.edit_data.commune_list.map(el => ({
          province_code: el.province_code,
          district_code: el.district_code,
          commune_code: el.commune_code,
          arrival_time: el.arrival_time,
          duration_in_minute: el.duration_in_minute
        }))
      }
    }
  }
}
</script>
